import React from 'react';
import BrandLoader from '../../components/shared/brand/BrandLoader';

/** Full-screen boot/auth loading — brand ring-draw on the plain brand background. */
const LoadingScreen: React.FC = () => <BrandLoader fullscreen size="xl" />;

export default LoadingScreen;
